module.exports = __webpack_public_path__ + "static/media/19ESCAP42.64aff37e.jpg";